<template>
  <div class="time-input field has-addons">
    <div class="control">
      <input
        :disabled="disabled"
        ref="input"
        class="input"
        :class="{'is-danger': valid === false}"
        type="text"
        v-model="inputStr"
        :placeholder="placeholder"
        pattern="[0-9]*"
        @focus="onFocus"
        @blur="onBlur"
        @keyup.delete="onBackspace"
        @input="onKeypress">
    </div>
    <div class="control">
      <a class="button" :class="{'is-danger': valid === false}" :disabled="disabled" @click="onAmPmClick">{{ amPm }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeInput',
  props: ['value', 'date', 'am', 'pm', 'disabled', 'valid'],
  data () {
    return {
      inputStr: '',
      timeStr: '',
      amPm: 'am',
      time: 0,
      isString: false
    }
  },
  computed: {
    placeholder () {
      return this.timeStr.length ? this.timeStr : 'hh:mm'
    }
  },
  watch: {
    value () {
      if (!this.isString) {
        if (this.value) {
          this.time = this.$moment.unix(this.value)
          this.timeStr = this.time.format('h:mm')
          this.amPm = this.time.format('a')
          this.inputStr = this.timeStr
        } else {
          this.time = null
          this.timeStr = ''
          this.inputStr = ''
        }
      } else {
        this.initValueStr()
      }
    }
  },
  created () {
    if (typeof this.value === 'number') {
      let moment = this.$moment.unix(this.value)
      this.timeStr = moment.format('h:mm')
      this.inputStr = this.timeStr
      this.amPm = moment.format('a')
    } else if (typeof this.value === 'string') {
      this.initValueStr()
      this.isString = true
    } else {
      this.amPm = this.pm ? 'pm' : 'am'
    }
  },
  methods: {
    initValueStr () {
      let arr = this.value.split(' ')
      if (arr.length !== 2) {
        this.timeStr = ''
      } else {
        this.timeStr = arr[0]
        this.amPm = arr[1]
      }
      this.inputStr = this.timeStr
    },
    getDateMoment () {
      if (this.date) {
        return this.$moment.unix(this.date)
      } else {
        return this.$moment().startOf('day')
      }
    },
    onKeypress () {
      this.inputStr = this.prettyTime(this.inputStr)
      this.validateTime()
    },
    onBackspace () {
      if (!this.inputStr.length) {
        this.time = null
        this.timeStr = ''
        this.$refs.input.blur()
        this.timeUpdated()
      }
    },
    validateTime () {
      let dayMoment = this.getDateMoment()
      let str = `${this.inputStr} ${this.amPm}`
      let moment = this.$utils.timeStrToMoment(str, dayMoment)
      if (moment) {
        this.time = moment
        this.timeUpdated()
      }
    },
    onFocus () {
      this.inputStr = ''
    },
    onBlur () {
      this.inputStr = this.timeStr
    },
    onAmPmClick () {
      this.amPm = this.amPm === 'pm' ? 'am' : 'pm'
      this.validateTime()
    },
    prettyTime (str) {
      let s = str.replace(/[^0-9]/g, '')
      if (s.length === 3) {
        return s.substr(0, 1) + ':' + s.substr(1)
      } else if (s.length >= 4) {
        return s.substr(0, 2) + ':' + s.substr(2, 2)
      } else {
        return s
      }
    },
    timeUpdated () {
      if (!this.isString) {
        let time = 0
        if (this.time) {
          time = this.time.unix()
          this.timeStr = this.time.format('h:mm')
        } else {
          this.timeStr = ''
        }
        this.$emit('input', time)
      } else {
        this.$emit('input', this.time ? this.time.format('h:mm a') : '')
      }
    }
  }
}
</script>
